<app-three-column-template
  [hasCustomMain]="true"
  [pageData]="pageData()"
  [showTags]="false">

  <app-side-navigation [pageData]="pageData()" slot="left-section"></app-side-navigation>
  <app-breadcrumbs [pageData]="pageData()" slot="breadcrumb-section"></app-breadcrumbs>

  @if (pageData().showContents) {
    <app-toc></app-toc>
  }
  <app-ck-viewer
    [fullBody]="true"
    [htmlDescription]="pageData()?.htmlDescription"></app-ck-viewer>

  @if (pageData()) {
    <app-collections [pageData]="pageData()"/>
  }

  @if (isAllowed()) {
    <app-horizontal-divider></app-horizontal-divider>
    @if (pageData() && pageData().items && pageData().items?.items?.length) {
      <div class="related-publications">
        <div class="title-h2">{{ 'Related meetings'|translate }}</div>
        @for (item of pageData().items.items //noinspection ForBlockNonIterableVar; track item.id; let last = $last) {
          <app-meeting-card [hasDesc]="true"
                            [isLast]="last"
                            [meetingData]="item"></app-meeting-card>
        }

        <app-see-all
          [contentType]="E_CONTENT_TYPE.Meetings"
          [relatedId]="pageData().id"
          seeAllText="See all related">
        </app-see-all>

      </div>
    }

  }

  <ng-container slot="right-section">
    <app-links-section
      [isQuickLinks]="true"
      [links]="pageData()?.quickUrls"
      [title]="'Quick links'"></app-links-section>

    <app-default-portlets [pageData]="pageData()"></app-default-portlets>

    <app-links-section
      [links]="pageData()?.latestMeetings"
      [title]="'Latest meetings'"></app-links-section>

    <app-links-section
      [links]="pageData()?.upcomingMeetings"
      [title]="'Upcoming meetings'"></app-links-section>


  </ng-container>


</app-three-column-template>
